export const CHANNELS = [
  { name: 'Main Latest', value: 'MAIN_LATEST' },
  { name: 'Main Stable', value: 'MAIN_STABLE' },
  { name: 'LS', value: 'LS' },
  { name: 'Baseline', value: 'BASELINE' },
];

/**
 *
 * @param {GQL result object} res Result object expecting: result (string), details (string)
 * @returns
 */
export const errorToText = (res) => {
  if (!res) return 'An unknown error occured';

  switch (res.result) {
    case 'INVALID_VERSION':
      return `Invalid version. ${res.details || ''}`;
    case 'VERSION_EXISTS':
      return `Version already exists. ${res.details || ''}`;
    case 'BUNDLE_NOT_FOUND':
      return `Release bundle not found. ${res.details || ''}`;
    case 'RELEASE_BUNDLE_BUILD_NOT_FOUND':
      return `Release bundle build not found. ${res.details || ''}`;
    case 'PACKAGE_NOT_FOUND':
      return `Package not found. ${res.details || ''}`;
    case 'PACKAGE_TEMPLATE_NOT_FOUND':
      return `Upgrade package template not found. ${res.details || ''}`;
    case 'UPGRADE_PACKAGE_NOT_FOUND':
      return `Upgrade package not found. ${res.details || ''}`;
    case 'PACKAGE_ALREADY_EXISTS':
      return `Package already exists. ${res.details || ''}`;
    case 'ERROR':
      return `An unexpected error occured. ${res.details || ''}`;
    default:
      return 'An unknown error occured';
  }
};

export const channelToText = (channelType) => {
  const channel = CHANNELS.find((ch) => ch.value === channelType);
  if (channel) return channel.name;
  return channelType;
};

/**
 * Removes the patch version from a semver version string
 * @param {string} version A semver version string
 * @returns {string} The major and minor version of the input
 */
export const removePatchVersion = (version) => {
  const parts = version.split('.');
  if (parts.length < 2) return version;
  return `${parts[0]}.${parts[1]}`;
};
